/*------------------------------------*\
    MODULES
\*------------------------------------*/
import $ from "jquery";

/*------------------------------------*\
    SEARCH MODULE
\*------------------------------------*/
class Search {
    constructor(passedElement) {
        let self = this;

        self.elem = passedElement;
        self.toggle = self.elem.querySelector('[data-search-toggle]');
        self.search = self.elem.querySelector('[data-search]');
        self.toggleIsOpen = false;
    }

    init() {
        let self = this;

        self.toggle.addEventListener('click', evt => {
            if(self.toggleIsOpen) {
                self.closeToggle();
            } else {
                self.openToggle();
            }
        });
    }

    openToggle() {
        let self = this;

        self.toggle.classList.add('is-active');
        self.toggle.setAttribute('aria-expanded', true);
        self.elem.classList.add('is-active');
        self.toggleIsOpen = true;
    }

    closeToggle() {
        let self = this;

        self.toggle.classList.remove('is-active');
        self.toggle.setAttribute('aria-expanded', false);
        self.elem.classList.remove('is-active');
        self.toggleIsOpen = false;
    }
}

export default Search;
